import React, { memo } from 'react';

import { Modal } from 'Components/Modal';

import { PurpleButton } from 'Components/Button';
import { formatDate } from 'Utils/helpers';

import { areEqual } from 'Utils/equalityChecks';
import classes from './deleteAtmosphericLogModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;

  // log variable
  moistureLog: any;
  damageMaterial: any;

  // modal functions
  onDeleteButtonClick: (e: any) => void;
  closeModal: (e: any) => void;
}

function DeleteMoistureLogModal({ isOpen, moistureLog, damageMaterial, onDeleteButtonClick, closeModal }: Props) {
  return (
    <Modal
      title="Delete Moisture Log?"
      isOpen={isOpen}
      classes={classes}
      modalHeader
      dataBsBackdrop="static"
      dataBsKeyboard="false"
      modalCloseClick={closeModal}
    >
      <div className={classes.modalBody}>
        <p>
          Are you sure you want to delete this reading for <b>{damageMaterial?.materialName}</b>
          ?
          <br />
        </p>
        <div className={classes.logInfo}>
          <div className={classes.logItem}>
            <div>Date</div>
            <span>{moistureLog?.created_at ? formatDate(moistureLog?.created_at, 'PP') : ''}</span>
          </div>
          <div className={classes.logItem}>
            <div>Average</div>
            <span>{moistureLog?.removed ? 'Removed' : moistureLog?.reading ?? ''}</span>
          </div>
        </div>
        <p>You will not be able to undo this action.</p>
      </div>

      <div className={`modal-footer ${classes.modalFooter}`}>
        <PurpleButton onClick={closeModal} className={classes.cancelButton}>
          Cancel
        </PurpleButton>
        <PurpleButton onClick={onDeleteButtonClick} className={classes.deleteButton}>
          Delete
        </PurpleButton>
      </div>
    </Modal>
  );
}

const DeleteMoistureLogModalMemo = memo(DeleteMoistureLogModal, areEqual);
export { DeleteMoistureLogModalMemo as DeleteMoistureLogModal };
